import { createApi } from "@reduxjs/toolkit/query/react";
import { createRetryingBaseQuery } from "../retryingBaseQuery";
import fetchAllPages from "../../utils/fetchAllPages";

const baseQuery = createRetryingBaseQuery(process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE ?? "");

export const debounceOverrideAPI = createApi({
  reducerPath: "debounceOverrideAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetDebounceOverrides"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET DEBOUNCE OVERRIDES BY BANK */
    getDebounceOverrides: builder.query({
      queryFn: async (body: any, _queryApi, _extraOptions, _baseQuery) =>
        fetchAllPages(
          _baseQuery,
          `/debounce-overrides/?page=1&limit=500&filter_target=bank_id&filter=${body.bankId}`,
          { authorization: body.token },
        ),
      providesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* POST DEBOUNCE OVERRIDE */
    postDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
      extraOptions: { fbSerializer: "CreateDebounceOverride" },
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* PUT DEBOUNCE OVERRIDE */
    putDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/${body.id}`,
        method: "PUT",
        body: { id: body.id, ...body.body },
        headers: { authorization: body.token },
      }),
      extraOptions: { fbSerializer: "UpdateDebounceOverride" },
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
    //* *********************************************************** */
    //* DELETE DEBOUNCE OVERRIDE */
    deleteDebounceOverride: builder.mutation({
      query: (body: any) => ({
        url: `/debounce-overrides/${body.id}`,
        method: "DELETE",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetDebounceOverrides"],
    }),
  }),
});

export const {
  useLazyGetDebounceOverridesQuery,
  usePostDebounceOverrideMutation,
  usePutDebounceOverrideMutation,
  useDeleteDebounceOverrideMutation,
} = debounceOverrideAPI;
